module.exports = __webpack_public_path__ + "static/img/11_northern_japan.d240292d.png";